import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { ChromePicker } from 'react-color';
import { ColorCover, ColorPopover, ColorSelectIcon, Root } from '../styles';
const ColorsInput = (props) => {
    const { id, caption, tooltip, value, size = 'small', inside = false, disabled = false, onChange } = props;
    const [visible, setVisible] = useState(false);
    const handleClick = () => {
        setVisible(!visible);
    };
    const handleClose = () => {
        setVisible(false);
    };
    const inputProps = {
        endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { disabled: disabled, onClick: handleClick, children: _jsx(ColorSelectIcon, { value: value }) }) })),
    };
    const onValueChange = (e) => {
        onChange?.(e.target.value);
    };
    const onColorChange = (color) => {
        const { r = 0, g = 0, b = 0, a = 1 } = color?.rgb ?? {};
        onChange?.(a === 1 ? `rgb(${r}, ${g}, ${b})` : `rgba(${r}, ${g}, ${b}, ${a})`);
    };
    return (_jsxs(Root, { relative: true, size: size, inside: inside, button: true, children: [_jsx(TextField, { id: id, label: caption, helperText: tooltip, value: value, variant: "outlined", size: "small", disabled: disabled, InputProps: inputProps, onChange: onValueChange }), visible && (_jsxs(ColorPopover, { children: [_jsx(ColorCover, { onClick: handleClose }), _jsx(ChromePicker, { color: value, onChange: onColorChange })] }))] }));
};
export default ColorsInput;
//# sourceMappingURL=ColorsInput.js.map